import { render, staticRenderFns } from "./OrderYhq.vue?vue&type=template&id=215d1d24&scoped=true&"
import script from "./OrderYhq.vue?vue&type=script&lang=js&"
export * from "./OrderYhq.vue?vue&type=script&lang=js&"
import style0 from "./OrderYhq.vue?vue&type=style&index=0&id=215d1d24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d1d24",
  null
  
)

export default component.exports